import React, { createContext, useContext, useState, useEffect } from 'react';
import axiosInstance from 'src/utils/axiosConfig';
import { getUserDetails } from 'src/dataproviders/users/userDataProviders';

interface AuthContextType {
    isAuthenticated: boolean;
    user: any | null;
    googleLogin: () => Promise<void>;
    logout: () => Promise<void>;
    checkAuth: () => Promise<void>;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function AuthProvider({ children }: { children: React.ReactNode }) {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [user, setUser] = useState<any | null>(null);
    const [organization, setOrganization] = useState<any | null>(null);

    const logoutUser = () => {
        setIsAuthenticated(false);
        setUser(null);
        setOrganization(null);
        if (window.location.pathname !== '/signin') {
            window.location.href = '/signin';
        }
    };

    

    const checkAuth = async () => {
        try {
            const response = await getUserDetails();
            if (response.status === 200) {
                setUser(response.data.user);
                setOrganization(response.data.organization);
                setIsAuthenticated(true);
                if((!response.data.organization || !response.data.organization.is_active) && window.location.pathname !== '/setup') {
                    window.location.href = '/setup';
                }
            }
        } catch (error) {
            logoutUser();
        }
    };

    const googleLogin = async () => {
        console.log('Redirecting to Google login...');
        window.location.href = '/auth/google/login';
    };

    const logout = async () => {
        console.log('Logging out...');
        try {
            const response = await axiosInstance.post('/auth/logout', {});
            if (response.status === 200) {
                logoutUser();
            } else {
                console.error('Logout failed');
            }
        } catch (error) {
            console.error('Error during logout:', error);
            // Even if there's an error, try to redirect to signin
            window.location.href = '/signin';
        }
    };

    useEffect(() => {
        checkAuth();
    }, []);

    return (
        <AuthContext.Provider value={{ isAuthenticated, user, googleLogin, logout, checkAuth }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const context = useContext(AuthContext);
    if (context === undefined) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
} 